module.exports = __webpack_public_path__ + "static/media/0026_IMG_LES_MURS_P21_UNI_CRISTAL_HORIZONTALE.42737bcd.webp";